import axios from 'axios';
import AuthService from './msal';
import moment from 'moment';
import jwt_decode from "jwt-decode";

const service = axios.create({
    timeout: 8000
});

service.interceptors.request.use(async config => {
    config.headers['Content-Type'] = 'application/json';

    config.headers['tenant'] = localStorage.tenant;
    config.baseURL = localStorage.api_url;

    if(new Date() >= moment.unix(localStorage.getItem("expire")).subtract(4, 'minutes').toDate()){
        const Auth = new AuthService();

        try{
            let refreshResponse = await Auth.refresh();
            console.log(refreshResponse,"REFRESH");

            if(localStorage.getItem("redirectInProgress") && localStorage.getItem("redirectInProgress") == "true"){
                console.log("Redirect from refresh");
            }else{
                if(refreshResponse.idToken){
                    localStorage.customToken = refreshResponse.idToken;
                    let decoded = jwt_decode(refreshResponse.idToken);
                    localStorage.setItem("expire",decoded.exp);
                }else{
                    console.log(refreshResponse,"CANNOT REFRESH");
                    Auth.logout();
                }
            }
        }catch(refreshError){
            console.log(refreshError,"REFRESH ERROR");
            Auth.logout();
        }
    }

    config.headers['Authorization'] = 'Bearer ' + localStorage.customToken;

    return config;
}, error => {
    // console.log(error)
    Promise.reject(error)
});

service.interceptors.response.use(
    response => response,
    error => {
        return Promise.reject(error.response)
    }
);

export {service};
